<template>
  <div>
    <div class="mb-2 flex justify-center">
      <img :src="icon" />
    </div>
    <p class="text-center text-xs">{{ label }}</p>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  icon: string;
  label: string;
}>();
</script>
